import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import FAQSection from './components/FAQSection';
import { faqs } from '@/mocks/faqs';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '女仆不只是工作',
  url: 'https://alyonvc.cn/',
  description: '探索女仆文化背后的情感连接、角色认同与生活方式。用深度内容重新定义女仆文化的多元价值。',
  inLanguage: 'zh-Hans',
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '女仆不只是工作编辑部',
  url: 'https://alyonvc.cn/',
  description: '专注于女仆文化深度内容创作与传播的文化媒体平台。',
};

const webpageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '女仆不只是工作 - 首页',
  description: '探索女仆文化背后的情感连接、角色认同与生活方式。深度文章、真实故事与多元视角，重新定义女仆文化的价值。',
  url: 'https://alyonvc.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '女仆不只是工作',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((faq) => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer,
    },
  })),
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg type="Organization" data={organizationSchema} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webpageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}